export default class Variables {
    constructor(client) {
        this.client = client
    }

    get(key) {
        const requestKey = 'variables.get'
    
        let params = {
            name: key
        }
        return this.client._postMessageWithPromise(requestKey, params)
    }

    set(key, value, visibility) {
        const requestKey = 'variables.set'
    
        let params = {
            name: key,
            value: value,
            visibility: visibility
        }
        return this.client._postMessageWithPromise(requestKey, params)
    }

    delete(key) {
        const requestKey = 'variables.delete'
    
        let params = {
            name: key
        }
        return this.client._postMessageWithPromise(requestKey, params)
    }
}